export default [
    {
        path: 'relatorio-consumo-financeiro',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-consumo-financeiro' */
            '@/views/almoxarifado/relatorio-consumo-financeiro/Index'
        ),
        redirect: 'relatorio-consumo-financeiro/index',
        children: [
            {
                name: 'almoxarifado-relatorio-consumo-financeiro-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-consumo-financeiro' */
                    '@/views/almoxarifado/relatorio-consumo-financeiro/List.vue'
                ),
            },
        ],
    },
]